import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import NoReport from '../../assets/noreport.png';
import {useTranslation} from "react-i18next";

const NoContent = ({disable,handleClick}) => {
    const {t} = useTranslation();
    return (
        <Box sx={{display: 'flex',alignItems:'center',justifyContent:'center',flexDirection:'column', minHeight: '70vh'}} >
            <img src={NoReport} />
            <Typography variant="paragraph" component="div" sx={{maxWidth:'400px', textAlign:'center', mb:'24px',mt:'18px'}}>
              {t('nav.desertHelperText')}
            </Typography>
            <Button disabled={disable} onClick={() => handleClick()} variant="contained" disableElevation color="success" sx={{background:'#00AD6F',paddingLeft:'53px',paddingRight:'53px', textTransform:'none'}}>
              {t('nav.newReport')}
            </Button>
      </Box>
    )
}

export default NoContent;
